<template>
  <div>
    <vm-table ref="vmTable" :filter.sync="filter" module="basic" url="projects">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.edit.open(0)">新建</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="项目编号">
            <el-input v-model.trim="filter.projectNo" placeholder="请输入" clearable />
          </vm-search>
          <vm-search label="项目名称">
            <el-input v-model.trim="filter.projectName" placeholder="请输入" clearable />
          </vm-search>
          <vm-search label="状态">
            <el-select v-model="filter.status" clearable placeholder="请选择">
              <el-option v-for="item in constant.toSelect(constant.programStatus)" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="projectNo" align="center" label="项目编号" width="120">
        <template slot-scope="scope">
          <a @click="$refs.edit.open(scope.row.pkid, true)">{{ scope.row.projectNo }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="项目名称" show-overflow-tooltip />
      <el-table-column prop="projectMangerName" align="center" label="项目经理" width="100" />
      <el-table-column prop="projectTeamNames" label="项目成员" show-overflow-tooltip />
      <el-table-column prop="planBeginDate" align="center" label="计划开工日期" width="120" />
      <el-table-column prop="planFinishDate" align="center" label="计划完工日期" width="120" />
      <el-table-column prop="beginDate" align="center" label="实际开工日期" width="120" />
      <el-table-column prop="finishDate" align="center" label="实际完工日期" width="120" />
      <el-table-column prop="status" align="center" label="状态" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="info" effect="dark">未启动</el-tag>
          <el-tag v-else-if="scope.row.status === 2" effect="dark">进行中</el-tag>
          <el-tag v-else-if="scope.row.status === 3" type="success" effect="dark">已完成</el-tag>
          <el-tag v-else type="danger" effect="dark">挂起</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="creatorName" align="center" label="创建人" width="120" />
      <el-table-column prop="createdTime" align="center" label="创建时间" width="140" />
      <el-table-column label="操作" align="center" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button :disabled="isAuth(scope.row)" type="info" @click="$refs.edit.open(scope.row.pkid)">
            编辑
          </el-button>
          <el-button :disabled="isAuth(scope.row)" type="danger" @click="deleteHandle(scope.row.pkid)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
    <program-edit ref="edit" @save-success="getList(1)" />
  </div>
</template>

<script>
import VmTable from "@/components/VmTable.vue";
import VmSearch from "@/components/VmSearch.vue";
import ProgramEdit from "@/views/projectManage/program/ProgramEdit";
import constant from "@/util/constant";
import auth from "@/util/loginUtil";

export default {
  name: "Program",
  components: { VmTable, VmSearch, ProgramEdit },
  data() {
    return {
      constant,
      authName: auth.getUserName(),
      currentUserId: auth.getUserId(),
      filter: {
        projectNo: "",
        projectName: "",
        status: "",
      },
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    isAuth(data) {
      if (this.authName === 'admin') {
        return false;
      } else if (this.currentUserId === data.creatorId) {
        return false;
      } else {
        return true;
      }
    },

    getList(pageNo) {
      this.$refs.vmTable.getList(pageNo);
    },

    deleteHandle(pkid) {
      this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
        this.$http
          .delete("basic", "projects", pkid).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
      });
    },
  },
};
</script>